// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-shell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 24px;
  background: var(--surface);
  color: var(--text);
  border-bottom: 1px solid var(--border);
  position: relative;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1 1 auto;
}

.nav-logo {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: var(--button-text);
  overflow: hidden;
}

.nav-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-size: 1.05rem;
  font-weight: 700;
}

.nav-links {
  display: flex;
  gap: 12px;
}

.nav-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.profile-menu-wrap {
  position: relative;
}

.profile-trigger {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--border);
  overflow: hidden;
  padding: 0;
  cursor: pointer;
  background: var(--surface-strong);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text);
  font-weight: 700;
}

.profile-trigger img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nav-toggle.discord-login-button {
  white-space: nowrap;
  background: #5865f2;
  color: white;
  border: 1px solid #5865f2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.nav-toggle.discord-login-button:hover {
  background: #4752c4;
  color: white;
}

.discord-login-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.discord-login-icon svg {
  width: 20px;
  height: auto;
}

.profile-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 180px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  padding: 8px;
  display: grid;
  gap: 4px;
  z-index: 80;
}

.profile-menu-item {
  border: none;
  background: transparent;
  color: var(--text);
  text-align: left;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
}

.profile-menu-item:hover {
  background: var(--surface-strong);
}

.nav-links {
  flex: 0 1 auto;
}

.nav-link,
.nav-toggle {
  border: none;
  background: transparent;
  color: var(--muted-strong);
  font-weight: 600;
  cursor: pointer;
  padding: 10px 14px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.nav-link.active,
.nav-link:hover,
.nav-toggle:hover {
  color: var(--button-text);
  background: var(--button-bg);
}

/* Mobile / touch behavior: collapse links into hamburger */
@media (max-width: 900px) {
  .nav-links {
    display: none;
  }

  .nav-menu-button {
    display: inline-flex !important;
  }

  .nav-title {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* Also apply when the app sets the is-mobile class */
.is-mobile .nav-links {
  display: none;
}
.is-mobile .nav-menu-button {
  display: inline-flex;
}
.is-mobile .nav-title {
  /* max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  display: none;
}

/* When menu open, show links as dropdown */
.nav-links.open,
.is-mobile .nav-links.open {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  padding: 12px;
  gap: 8px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  z-index: 60;
}

/* Hide the explicit menu button on wide screens */
.nav-menu-button {
  display: none;
}

/* Ensure theme toggle is always visible */
.theme-toggle {
  display: inline-flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/NavigationBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,2DAA2D;AAC3D;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE;;;wBAGsB;EACtB,aAAa;AACf;;AAEA,2CAA2C;AAC3C;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,sCAAsC;EACtC,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;AACtB","sourcesContent":[".nav-shell {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 24px;\r\n  padding: 18px 24px;\r\n  background: var(--surface);\r\n  color: var(--text);\r\n  border-bottom: 1px solid var(--border);\r\n  position: relative;\r\n}\r\n\r\n.nav-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.nav-logo {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 800;\r\n  color: var(--button-text);\r\n  overflow: hidden;\r\n}\r\n\r\n.nav-logo img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.nav-title {\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.nav-links {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.nav-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.profile-menu-wrap {\r\n  position: relative;\r\n}\r\n\r\n.profile-trigger {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  border: 1px solid var(--border);\r\n  overflow: hidden;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  background: var(--surface-strong);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--text);\r\n  font-weight: 700;\r\n}\r\n\r\n.profile-trigger img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.nav-toggle.discord-login-button {\r\n  white-space: nowrap;\r\n  background: #5865f2;\r\n  color: white;\r\n  border: 1px solid #5865f2;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.nav-toggle.discord-login-button:hover {\r\n  background: #4752c4;\r\n  color: white;\r\n}\r\n\r\n.discord-login-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.discord-login-icon svg {\r\n  width: 20px;\r\n  height: auto;\r\n}\r\n\r\n.profile-menu {\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  min-width: 180px;\r\n  background: var(--surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  box-shadow: var(--card-shadow);\r\n  padding: 8px;\r\n  display: grid;\r\n  gap: 4px;\r\n  z-index: 80;\r\n}\r\n\r\n.profile-menu-item {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text);\r\n  text-align: left;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-menu-item:hover {\r\n  background: var(--surface-strong);\r\n}\r\n\r\n.nav-links {\r\n  flex: 0 1 auto;\r\n}\r\n\r\n.nav-link,\r\n.nav-toggle {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--muted-strong);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  padding: 10px 14px;\r\n  border-radius: 12px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.nav-link.active,\r\n.nav-link:hover,\r\n.nav-toggle:hover {\r\n  color: var(--button-text);\r\n  background: var(--button-bg);\r\n}\r\n\r\n/* Mobile / touch behavior: collapse links into hamburger */\r\n@media (max-width: 900px) {\r\n  .nav-links {\r\n    display: none;\r\n  }\r\n\r\n  .nav-menu-button {\r\n    display: inline-flex !important;\r\n  }\r\n\r\n  .nav-title {\r\n    max-width: 120px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n/* Also apply when the app sets the is-mobile class */\r\n.is-mobile .nav-links {\r\n  display: none;\r\n}\r\n.is-mobile .nav-menu-button {\r\n  display: inline-flex;\r\n}\r\n.is-mobile .nav-title {\r\n  /* max-width: 120px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap; */\r\n  display: none;\r\n}\r\n\r\n/* When menu open, show links as dropdown */\r\n.nav-links.open,\r\n.is-mobile .nav-links.open {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  padding: 12px;\r\n  gap: 8px;\r\n  background: var(--surface);\r\n  border-bottom: 1px solid var(--border);\r\n  z-index: 60;\r\n}\r\n\r\n/* Hide the explicit menu button on wide screens */\r\n.nav-menu-button {\r\n  display: none;\r\n}\r\n\r\n/* Ensure theme toggle is always visible */\r\n.theme-toggle {\r\n  display: inline-flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
